import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import Context from './Context';
const CookiesAcceptedLocalStorageName = 'CookiesAccepted';
const Loader = ({ children }) => {
    const getAcceptedFromLocalStorage = () => {
        return localStorage.getItem(CookiesAcceptedLocalStorageName) === 'true';
    };
    const setAcceptedToLocalStorage = (accepted) => {
        localStorage.setItem(CookiesAcceptedLocalStorageName, accepted ? 'true' : 'false');
    };
    const [accepted, setAccepted] = useState(getAcceptedFromLocalStorage());
    const setAcceptedHandler = (accepted) => {
        setAcceptedToLocalStorage(accepted);
        setAccepted(accepted);
    };
    const clearAccepted = () => {
        localStorage.removeItem(CookiesAcceptedLocalStorageName);
        setAccepted(getAcceptedFromLocalStorage());
    };
    return (_jsx(Context.Provider, Object.assign({ value: { accepted, clearAccepted, setAccepted: setAcceptedHandler, storageName: CookiesAcceptedLocalStorageName } }, { children: children }), void 0));
};
export default Loader;
//# sourceMappingURL=Loader.js.map